var app = angular.module('leonardo');

var FormTextarea = function(FilterService, $timeout, $compile) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      ckeditor: '=ngCkeditor',
      blur: '&ngBlur',
      label: '@',
      name: '@',
      rows:'@',
      placeholder: '@',
      message_required: '@messageRequired',
      initialdata: '=',
    },
    templateUrl: 'views/templates/form/form-textarea.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.value1 = null;
      scope.textarea = element.find('.form-textarea');
      scope.name = scope.name || 'value';

      scope.isNull = isNull;

      scope.$watch('value', function (value) {
        scope.ngModelCtrl.$setViewValue(value);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, value);
        }
      });

      scope.$watch('value1', function (value) {
        scope.value = angular.copy(value);
      });

      scope.ngModelCtrl.$render = function () {

        scope.value = scope.ngModelCtrl.$viewValue;
        scope.value1 = scope.ngModelCtrl.$viewValue;
        if (!scope.value && scope.filter) {
          scope.value = FilterService.getFilter(scope.filter);
        }
      };

      scope.ckeditorOptions = {
        language: 'en',
        allowedContent: true,
        entities: false
      };

      scope.getCharRemaining = function() {
        var valueLength = scope.value ? scope.value.length : 0;
        return scope.maxlength - valueLength;
      };

      scope.updateValue = function (data) {
        scope.value = data;
      };

      if (scope.ckeditor) {
        $timeout(function () {
          scope.textarea.attr('ckeditor', 'ckeditorOptions');
          $compile(scope.textarea)(scope);
          CKEDITOR.instances[scope.name].on('instanceReady', function() {
            CKEDITOR.instances[scope.name].on('maximize',function(){
                $("html").removeAttr("style");
                $("body").removeAttr("style");
            })
            if(scope.name === 'text' && !scope.initialdata.onopen){
              scope.initialdata.data = CKEDITOR.instances[scope.name].getData();
            }
            CKEDITOR.instances[scope.name].document.on('keydown', function() {
              $timeout(function() {
                var data = CKEDITOR.instances[scope.name].getData();
                if (isNull(scope.value1) && !isNull(data)) {
                  scope.value = angular.copy(data);
                }
                else {
                  scope.value = angular.copy(scope.value1);
                }
              }, 100);
            });
          });
        });
      }
      else {
        element.find('textarea').bind("keydown keypress", function () {
          $timeout(function() {
            scope.value = scope.textarea.val();
          }, 10);
        });
      }

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        return !isNull(modelValue);
      };

      scope.ngModelCtrl.$validators.minlength = function(modelValue) {
        if (!scope.minlength) {
          return true;
        }
        return !isNull(modelValue) && modelValue.length >= scope.minlength;
      };

      scope.ngModelCtrl.$validators.maxlength = function(modelValue) {
        if (!scope.maxlength) {
          return true;
        }
        return isNull(modelValue) || modelValue.length <= scope.maxlength;
      };
    }
  };
};

app.directive('formTextarea', ['FilterService', '$timeout', '$compile', FormTextarea]);
